import PDFTableRow from "components/PDF/Table/TableRow";
import { Text } from "@react-pdf/renderer";
import { formatMoney } from "infra/helpers/number";

interface PDFRelatorioReceitasTotalRowProps {
  title: string;
  valorTotal: number;
}

function TotalRow({ title, valorTotal }: PDFRelatorioReceitasTotalRowProps) {
  return (
    <PDFTableRow
      backgroundColor={"white"}
      item={{
        title,
        valorTotal,
      }}
      columns={[
        {
          flexGrow: 7,
          title: "Total",
          render: (item) => <Text>{item.title}</Text>,
        },
        {
          flexGrow: 1,
          title: "total",
          render: (item) => (
            <Text style={{ marginLeft: "auto" }}>
              {formatMoney(item.valorTotal)}
            </Text>
          ),
        },
      ]}
    />
  );
}

export default TotalRow;
